<template>
  <div id="app">
    <router-view />
    <div v-if="hashChanged" class="refresh-container">
      <div class="notification-body">
        <div class="notification-button">
          <p class="text-center font12">An update is available. Please click update below. You can also accept these updates by refreshing your browswer with ctrl + f5 at any time.</p>
          <p class="text-center"><span class="font10">Not updating may result in errors.</span></p>
        </div>
        <div class="refresh-button text-center">
          <button class="btn btn__primary" @click="reloadApp">Update</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { refreshPageMixin } from '@/components/designComponents/refresh-page.mixin'
export default {
  name: 'App',
  mixins: [refreshPageMixin]
}
</script>

<style lang="scss" scoped>
.refresh-container {
  width: 45%;
  position: fixed;
  top: 80px;
  right: 15px;
  background-color: blue;
  color: white;
  padding: 25px;
  -webkit-box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
  -moz-box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
  box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
}
</style>

